export const PLAYER = 'Player';
export const DEALER = 'Dealer';
export const PUSH = 'Push';

export const PLAYER_HAND = 'Player';
export const DEALER_HAND = 'Dealer';
export const SIDE_BETS = 'sideBets';

export const RESULT_WIN = 'Win';
export const RESULT_LOSE = 'Lose';
export const RESULT_PUSH = 'Push';
export const RESULT_DEALER_DISQUALIFIED = 'DealerDisqualified';

export const NO_WELCOME_DIALOG = 'NO_WELCOME_DIALOG_3CP';
export const WELCOME_DIALOG = 'WelcomeDialog';

export const HIGH_CARD = 'HighCard';
export const ONE_PAIR = 'OnePair';
export const THREE_OF_KIND = 'ThreeOfKind';
export const FOUR_OF_KIND = 'FourOfKind';
export const TWO_PAIRS = 'TwoPairs';
export const MINI_ROYAL = 'MiniRoyal';
export const STRAIGHT = 'Straight';
export const FLUSH = 'Flush';
export const FULL_HOUSE = 'FullHouse';
export const STRAIGHT_FLUSH = 'StraightFlush';
export const ROYAL_FLUSH = 'RoyalFlush';
